export default __webpack_public_path__ + "static/media/007.39dc24ef.jpeg";